export var name = 'sidebets';
export var SIDEBETS_SOCKET_PATH_NAME = 'sport-events/v1/ws/sideBetStatistic';
export var SIDEBETS_UPDATES_NAME = 'sideBetStatistic';
